<template>
  <div
    v-if="(title || image) && (imageUrl || backgroundColor)"
    class="position-relative header-container"
  >
    <div
      v-lazy:background-image="imageUrl"
      :style="{ backgroundColor }"
      class="header-inner-container"
    >
      <prismic-rich-text
        v-if="title"
        :field="title"
        class="title"
        :style="{ color: titleColor }"
      ></prismic-rich-text>
      <prismic-image v-else-if="image" :field="image" class="img-fluid mt-3 image-plans-header" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data: () => {
    return {
      title: '',
      titleColor: '',
      imageUrl: '',
      backgroundColor: '',
      image: ''
    };
  },

  async created() {
    const { primary } = this.slice;

    this.title = primary.title1[0]?.text ? primary.title1 : '';
    this.titleColor = primary.title_color ? primary.title_color : 'black';
    this.imageUrl = primary.background_image.url;
    this.backgroundColor = primary.background_color;
    this.image = primary.image;
  }
};
</script>

<style lang="scss" scoped>
.header-container {
  min-height: 110px;
  .header-inner-container {
    position: relative;
    overflow: hidden;
    min-height: 540px;
    border-radius: 5px;
    padding: 0px;
    background-size: cover;
    background-position: center center;
    position: absolute;
    width: 100%;
    text-align: center;
    .title {
      width: 50%;
      margin: 60px auto;
    }
  }
  @include lg {
    .header-inner-container .title {
      width: 100%;
      padding: 0 15px;
    }
  }
  @include sm {
    min-height: 60px;
    .header-inner-container {
      min-height: 280px;
      .title {
        margin: 35px auto;
      }
    }
  }
}

.image-plans-header {
  max-height: 150px;
  @include sm {
    max-height: 110px;
  }
}
</style>

<style lang="scss">
.header-container .header-inner-container .title {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 33px;
    @include sm {
      font-size: 23px;
    }
  }
}
</style>
